import { useState } from "react";
import { FileType, UploadOption } from "Types";

const FILE_STREAM_UPLOAD = "file-stream-upload";
const VERSION_UPLOAD = "version-upload";

function valueIsUploadOption(value: unknown): value is UploadOption {
  return (typeof value === "string" && value === "file") || value === "url";
}

const getOptionFromStorage = (fileType: FileType): UploadOption => {
  const storedUploadOption = localStorage.getItem(
    fileType === "FILESTREAM" ? FILE_STREAM_UPLOAD : VERSION_UPLOAD,
  );

  if (storedUploadOption && valueIsUploadOption(storedUploadOption)) {
    return storedUploadOption;
  }

  return "file";
};

type UseUploadOption = {
  uploadOption: UploadOption;
  handleUploadOptionChange: (option: UploadOption) => void;
};

const useUploadOption = (fileType: FileType): UseUploadOption => {
  const [uploadOption, setUploadOption] = useState<UploadOption>(() =>
    getOptionFromStorage(fileType),
  );

  const handleOptionChange = (option: UploadOption) => {
    localStorage.setItem(
      fileType === "FILESTREAM" ? FILE_STREAM_UPLOAD : VERSION_UPLOAD,
      option,
    );
    setUploadOption(option);
  };

  return {
    uploadOption,
    handleUploadOptionChange: handleOptionChange,
  };
};

export default useUploadOption;
